import React, { useEffect } from "react";
import "../../styles/SystemConfigManageTeam.css";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const beAddress =
  window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

const SystemConfigManageTeam: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const config = location.state?.config;

    // if (!config) {
    //   console.error(
    //     "⚠️ Missing config in SystemConfigManageTeam — redirecting."
    //   );
    //   navigate("/system-config", { replace: true });
    //   return;
    // }

    //  Fetch HR Configs using query param ?hr_name=<config.name>
    const fetchHrConfigs = async () => {
      try {
        const res = await axios.get(`${beAddress}/api/hr-configs`, {
          params: { portal_type: config.name },
          headers: {
            "user-uid": localStorage.getItem("user_uid") || "",
          }, withCredentials: true,
        });
      } catch (err) {
        console.error("❌ Error fetching HR Configs:", err);
      }
    };

    fetchHrConfigs();
  }, [location.state, navigate]);

  return (
    <div
      className="org-manage-container"
      style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}
    >
      {/* HR Info Configuration */}
      <div
        className="config-card clickable"
        onClick={() =>
          navigate("/system-level-config", {
            state: {
              mode: "view",
              config: location.state?.config,
            },
          })
        }
      >
        <h2 className="config-title">HR Info</h2>
        <p className="config-text">Manage HR info configuration here.</p>
      </div>

      {/* Level Configuration */}
      <div
        className="config-card clickable"
        onClick={() =>
          navigate("/level-configurations", {
            state: { config: location.state?.config },
          })
        }
      >
        <h2 className="config-title">Level Configuration</h2>
        <p className="config-text">Configuration options for levels go here.</p>
      </div>

      {/* Streak Configuration */}
      <div
        className="config-card clickable"
        onClick={() =>
          navigate("/streak-configurations", {
            state: { config: location.state?.config },
          })
        }
      >
        <h2 className="config-title">Streak Configuration</h2>
        <p className="config-text">
          Configuration options for streaks go here.
        </p>
      </div>
    </div>
  );
};

export default SystemConfigManageTeam;
